module.exports = __webpack_public_path__ + "assets/Heebo-Bold.5450bb73e0066fb5ca79f923e872a524.woff2";